
export function handleAxiosError(error) {
  if (error.response) {
    console.error("Server responded with error:", error.response);
    if (error.response.status === 400) {
      console.log(error.response.data);
    } else {
      console.log(
        `Upload failed [${error.response.status}]: ${error.response.data}`
      );
    }
  } else if (error.request) {
    console.error("No response received. Network error:", error.request);
    console.log("Network error. No response from server. File too large?");
  } else {
    console.error("Axios config or JS error:", error.message);
    console.log("Unexpected error: " + error.message);
  }
}
